import { render, staticRenderFns } from "./OTS.vue?vue&type=template&id=5be02b80&"
import script from "./OTS.vue?vue&type=script&lang=js&"
export * from "./OTS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports